<script setup>
import { concat, without } from 'lodash-es'

const { techsMap } = useTech()

const router = useRouter()
const route = useRoute()
const allTech = Object.keys(techsMap)
const tech = computed(() => route.query.tech?.split(',')?.filter(e => allTech.includes(e)) ?? [])
const selected = ref([])

function changeFilter (value) {
  const index = selected.value.findIndex((e) => e === value)

  selected.value = index > -1 ? without(selected.value, value) : concat(selected.value, value)

  router.push({
    query: selected.value.length === allTech.length ? {} : { tech: selected.value.join(',') }
  })
}

function resetFilter () {
  router.push({
    query: {}
  })
}

watch(tech, function (value) {
  selected.value = value.length > 0 ? value : Object.keys(techsMap)
}, {
  immediate: true
})
</script>

<template>
  <AppFilterButton>
    <template #icon>
      <div class="min-w-[24px]">
        <InlineSvg
          :src="`/images/filter.svg`"
          alt="Logo"
          title="Filter Button"
          class="size-[24px]" />
      </div>
    </template>
    <template #default>
      <div class="flex items-center gap-4">
        Filter
        <p
          v-if="selected?.length"
          class="flex size-[22px] items-center justify-center rounded-full bg-azure-radiance text-xs text-white">
          {{ selected.length ?? 1 }}
        </p>
      </div>
    </template>
    <template #buttons>
      <button
        type="button"
        class="flex justify-between gap-4"
        @click="resetFilter">
        <span>All</span>
      </button>
      <button
        v-for="t in allTech"
        :key="t"
        type="button"
        class="flex justify-between gap-4"
        @click="changeFilter(t)">
        <div class="flex items-center gap-4">
          <div class="w-[24px]">
            <InlineSvg
              :src="`/images/homepage/tech-${t}.svg`"
              alt="Logo"
              :title="techsMap[t]"
              class="size-[24px]"
              hard-code />
          </div>
          <span>{{ techsMap[t] }}</span>
        </div>
        <div class="w-5">
          <span v-if="selected.includes(t) || selected.length === 0">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.6 11.8L6.45 9.65C6.26667 9.46667 6.03333 9.375 5.75 9.375C5.46667 9.375 5.23333 9.46667 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.1 14.1 8.33333 14.2 8.6 14.2C8.86667 14.2 9.1 14.1 9.3 13.9L14.95 8.25C15.1333 8.06667 15.225 7.83333 15.225 7.55C15.225 7.26667 15.1333 7.03333 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20Z"
                fill="#00A3FF" />
            </svg>
          </span>
        </div>
      </button>
    </template>
  </AppFilterButton>
</template>
